<template>
  <SettingsPageTemplate>
    <template #heading>
      <h2>Holiday Calculation</h2>
    </template>
    <template #default v-if="!isLoading">
      <div>
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <form @submit.prevent="updateHolidayCount()">
              <div class="form-group mt-1">
                <label for="">Holiday Name: </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.name"
                  required
                />
              </div>
              <div class="form-group mt-1">
                <label for="">Holiday Count: </label>
                <input
                  type="number"
                  class="form-control"
                  v-model="formValue.count"
                  min="0"
                  max="7"
                  required
                />
              </div>
              <button type="submit" class="btn btn-primary mt-2">Submit</button>
            </form>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </template>
  </SettingsPageTemplate>
</template>

<script>
import SettingsPageTemplate from '@/components/settings/SettingsPageTemplate.vue';
import http from '@/config/axios';

export default {
  components: {
    SettingsPageTemplate
  },
  data() {
    return {
      isLoading: true,
      holidayInfo: {},
      formValue: {
        name: '',
        count: 0
      }
    };
  },
  mounted() {
    this.getHolidayInfo();
  },
  methods: {
    getHolidayInfo() {
      this.isLoading = true;
      http
        .get('v2/settings/holidays')
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
            this.holidayInfo = response.data.data;
            this.formValue.name = this.holidayInfo.name;
            this.formValue.count = this.holidayInfo.count;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert(error.response.data.msg);
          console.log(error);
        });
    },
    updateHolidayCount() {
      this.isLoading = true;
      http
        .post('v2/settings/holidays', this.formValue)
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
            this.$swal({
              icon: 'success',
              title: 'Success',
              text: response.data.message,
              showConfirmButton: false,
              timer: 1000
            });
            this.getHolidayInfo();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>

<style scoped></style>
